/**
 * Язык в адресе: где он есть и как перейти на другой.
 *
 * Отдельный модуль, потому что этими функциями пользуется и провайдер, и SEO, и
 * скрипт сборки статики — а из компонента их не экспортировать: файл с
 * компонентом и утилитами ломает горячую перезагрузку.
 */
import type { Lang } from './translations'

/**
 * Витрина: у неё есть отдельный адрес на язык, и он главнее памяти.
 *
 * Всё, что перечислено ниже, живёт ВНЕ витрины и своего русского адреса не
 * имеет — язык там хранится в браузере. Пропущенная в этом списке страница
 * стоит дорого сразу дважды: переключатель языка уводит человека на
 * несуществующий `/ru/...`, а карта сайта отправляет туда поисковик, и тот
 * получает 200 со словами «Not Found» — мягкая 404, которую Search Console
 * считает ошибкой. Именно так и случилось с `/language`.
 */
export function isLocalizedZone(path: string): boolean {
  return !/^\/(cabinet|my|psymodeler|language|design-system|signin|register|verify-email|forgot-password|reset-password|s)(\/|$)/.test(path)
}

export function isRussianPath(path: string): boolean {
  return path === '/ru' || path.startsWith('/ru/')
}

/** Тот же адрес на другом языке: `/courses` ↔ `/ru/courses`. */
export function pathInLang(path: string, lang: Lang): string {
  const bare = isRussianPath(path) ? path.slice(3) || '/' : path
  if (lang === 'en') return bare
  return bare === '/' ? '/ru' : `/ru${bare}`
}

